import { ReactPlugin } from "@microsoft/applicationinsights-react-js";
import {
  ApplicationInsights,
  DistributedTracingModes,
  IApplicationInsights,
  Snippet,
} from "@microsoft/applicationinsights-web";
import { AppContextType } from "@microsoft/metaos-appcontextutils";
import { config } from "../configs";

export const reactPlugin = new ReactPlugin();

const snippet: Snippet = {
  config: {
    instrumentationKey: config.instrumentationKey,
    enableCorsCorrelation: true,
    distributedTracingMode: DistributedTracingModes.AI_AND_W3C,
    extensions: [reactPlugin],
    enableAutoRouteTracking: true,
    disableAjaxTracking: false,
    autoTrackPageVisitTime: true,
    enableRequestHeaderTracking: true,
    enableResponseHeaderTracking: true,
  },
};

export const appInsights = new ApplicationInsights(snippet);
appInsights.loadAppInsights();

export const trackEvent = (
  appInsights: IApplicationInsights,
  eventName: string,
  context: AppContextType,
  customProperties: object = {},
) => {
  const userId = context.authData?.account?.username;

  if (userId && userId.includes("dining-tester")) {
    return;
  }

  appInsights.trackEvent(
    { name: eventName },
    {
      userId,
      correlationId: context.authData?.correlationId,
      sessionId: context.sessionId,
      appType: context.appType,
      ...customProperties,
    },
  );
};
